<template>
  <div class="container">
    <HeaderBar/>

    <no-ssr>
      <div class="pay-wrap">

        <div class="fixed_inner_center">
          <div class="service-wrap">
            <a :href="SERVICE_LINK" target="_blank">客服咨询</a>
          </div>
        </div>
        <div class="inner_center">

          <!--          <a
                      :href="PAGE_PATH.BASE_URL + PAGE_PATH.PAYMENT.UPGRADE"
                      target="_blank"
                      class="icon_upgrade"
                      v-if="(personVipState == 1 && personVipInfo.vip != 1 && personVipInfo.remaining_days <= 365)
                      ||
                      (businessVipState == 1 && businessVipInfo.remaining_days <= 365)
          "
                    >
                      限时福利：会员升级专属优惠，升级更高档位，享受更好权益
                    </a>-->

          <!-- banner介绍 -->
          <div class="banner-intro">
            <h1>全站通VIP会员—开通立享全站素材海量下载与商用授权</h1>
            <div class="equity-list">
              <div class="equity-item">源文件高速海量下载</div>
              <div class="equity-item">侵权赔付保障</div>
              <div class="equity-item">满足会员定制需求</div>
              <div class="equity-item">创建自定义收藏夹</div>
              <div class="equity-item">专属客服</div>
              <div class="equity-item">发票一键申请</div>
            </div>

          </div>

          <div class="pay-main">
            <div class="user-info">

              <div class="un-login" @click="showLogin" v-if="!isLogin">
                请登录
              </div>
              <div class="user-login" v-if="isLogin">
                <img class="user-avatar" :src="avatar" alt="">
                <span class="user-id">{{ uniq_id }}</span>
                <span class="user-vip-tip">请选择您要开通的VIP服务</span>
              </div>

              <a class="icon_tj" :href="NEW_YEAR_ACT" target="_blank">
                年终大促，
                <i class="color-yellow">全站通VIP年度史低价</i>
              </a>

            </div>

            <div class="pay-item pay-item-meal">
              <div
                class="pay-item-value meal-box">

                <div class="swiper-box">
                  <!--
                                      v-swiper:mySwiper3="swiperOption3"

                  -->
                  <div
                    class="swiper swiper3"
                  >
                    <div
                      class="member-list member-list2 swiper-wrapper">
                      <div
                        v-for="(vo,index) in vips[1].LIST"
                        :key="vo.ID"
                        :class="[vo.CLASS_NAME,{'on':vo.ID == id}]"
                        class="member-item swiper-slide"
                        @click="
                          toggleMemberItem(vo.ID);
                          checkVip(vo,index)
"
                        v-if="vo.isShow"
                      >
                        <div class="bg"/>
                        <div class="name">{{ vo.LABEL }}</div>
                        <div class="account-number">{{ vo.ACCOUNT_NUMBER }}个账号</div>
                        <div class="price">
                          <i class="icon_dollar">¥</i>
                          <span class="txt-price">{{ vo.PRICE }}</span>
                          <span class="time"> /{{vo.time}}</span>
                        </div>
                        <div class="down-num">
                          {{ vo.downloadNum || '全站海量下载' }}
                        </div>

                        <div class="line"></div>
                        <!--                          <i :class="['icon_vip-label', vo.tagClass]"/>-->

                        <!--                    <div class="item-box">-->
                        <!--                      <div class="item-lable">企业规模：</div>-->
                        <!--                      <div class="item-value">-->
                        <!--                        注册资本 <span class="color-orange">{{ vo.ziben }}</span>-->
                        <!--                      </div>-->
                        <!--                    </div>-->

                        <div class="item-box qy">
                          <div class="item-lable">下载权益：</div>
                          <div class="item-value">
                            <!--                        <div class="item-value-sub item-value-sub-bold">{{ vo.downloadNum || '全站海量下载' }}</div>-->
                            <!--                        <div class="item-value-sub">{{ vo.ACCOUNT_NUMBER }}个账号</div>-->
                             {{ vo.downTxt || '全站(企业专享+VIP专区+限时免费)' }}
                          </div>
                        </div>

                        <div class="item-box">
                          <div class="item-lable">授权范围：</div>
                          <div class="item-value item-value-fw"
                               :class=" { 'item-value-fw-one':  vo.quanyi.length == 1  }"
                          >
                            <div class="item-value-sub"
                                 v-for="qyItem in vo.quanyi"
                            >
                              <i class="iconfont" :class=" qyItem.value == 1 ? 'icon-gou22': 'icon-cha3' "></i>
                              {{ qyItem.label }}</div>
                          </div>
                        </div>
                        <div class="dj-tag" v-if="vo.discountDesc">
                          {{ payTimeId == 2 ?  (vo.discountDesc2 ||'买2年送1年') : vo.discountDesc }}
                        </div>
                        <div class="tag"></div>
                      </div>
                    </div>


                  </div>
                  <!-- Custom navigation buttons -->
                  <!--                  <div class="swiper-button-next"></div>-->
                  <!--                  <div class="swiper-button-prev"></div>-->
                </div>





              </div>
            </div>

<!--            <div class="durationWrap" v-if="durationActiveIds.indexOf(currentEquityInfo.ID) > -1">
              购买时长
              <div class="durationTab">

                <div class="durationTabItem"
                     :class="{  'active':item.id == payTimeId}"
                     v-for="(item,index) in [

                  {
                    label: '1年',
                    id: 1,
                  },
                   {
                  label: '2年',
                  id: 2,
                  },
                ]" :key="index"
                     @click="toggleDuration(item)"

                >
                  {{ item.label }}

                  <span class="durationTag" v-if="item.id == 2">
                    最高送1.5年
                  </span>
                </div>
              </div>

&lt;!&ndash;              <span class="line"></span>&ndash;&gt;
              <span class="endTime">到手{{  ActVipInfo.timeDesc  }}</span>
&lt;!&ndash;              <span class="durationGift">{{  ActVipInfo.timeDesc  }}</span>&ndash;&gt;
              <span class="durationGift">（有效期：{{  ActVipInfo.time  }}）</span>

              <span class="icon_arrow" :style="boxStyle"></span>
              <span class="icon_arrow2" :style="boxStyle"></span>
            </div>-->




            <!--            <div class="custom-vip">-->
            <!--              <div class="headline">若授权对象注册资本超1000万（或行政事业单位）请联系 <a :href="SERVICE_LINK" target="_blank">客户经理</a> 定制套餐</div>-->
            <!--              <div class="subhead">注册资本超1000万购买需要补差价定制升级，否则可能会无法正常使用哦～</div>-->
            <!--            </div>-->

            <div class="pay-item pay-item-money">
              <div class="pay-item-value">

                <div class="pay-item-col">
                  <!--                  <div class="real-coupon" v-if="couponList.length == 0 ">-->
                  <!--                    <span class="txt-price">¥200</span>-->
                  <!--                    <span class="txt-coupon">优惠券</span>-->
                  <!--                    <div class="txt-time">-->
                  <!--                      {{ times.h }}:{{ times.m }}:{{ times.s }}.{{ times.hm }}-->
                  <!--                    </div>-->
                  <!--                  </div>-->

                  <div class="CouponPulldownBox
" v-if="couponList.length">

                    <CouponPulldown
                      class="CouponPulldown"
                      :coupon-price="100"
                      :couponList="couponList"
                      @toggleCoupon="toggleCoupon"
                    />
                  </div>
                  <div class="payment-money">
                    <span class="txt-pay">应付金额：</span>
                    <span class="price">
                      <i class="icon_dollar">¥</i>
                      <!--                      {{ discountPrice }}-->
                      <!--                      {{  isLogin ? discountPrice : this.currentVipInfo.PRICE }}-->
                      <!--                      {{  isLogin ? 11111 : 22222 }}-->
                      {{ finalPrice }}
                    </span>
                    <!--                    <span class="txt-yuan">元</span>-->
                    <!--                  <span class="reduce-price" v-if="reducePrice > 0">已优惠：￥{{ reducePrice | disposeReducePrice }}</span>-->
                  </div>
                </div>



                <div class="time-box">
                  距今日活动结束：
                  <span class="h">{{ times.h }}</span>
                  <span class="txt-time">时</span>
                  <span class="m">{{ times.m }}</span>
                  <span class="txt-time">分</span>
                  <span class="s">{{ times.s }}.{{ times.hm }}</span>
                  <span class="txt-time">秒</span>
                </div>

                <template v-if="payWayIndex == 0">
                  <PicPayQrCode class="PayQrCode payment-box"
                                :payment-data="paymentData"
                                :isCertificate="isCertificate"
                  ></PicPayQrCode>

                  <div class="protocol">支付即同意
                    <NavigationTo :path="PROTOCOL_PAY_0">
                      <span slot="content" class="_pointer">《VIP服务协议》</span>
                    </NavigationTo>
                  </div>
                </template>



                <PayTransfer v-if="payWayIndex == 1" />





                <div class="pay-way">
                  <div class="pay-way-item"
                       :class="{ 'on' : index == payWayIndex }"
                       v-for="(item,index) in PAY_WAY"
                       :key="item.label"
                       @click=" payWayIndex = index "
                  >
                    <i class="iconfont" :class="item.icon"></i>
                    {{ item.label }}
                  </div>
                </div>


              </div>
            </div>


            <div class="text-sq">
              <!--              <span class="label">适用范围</span>-->
              <span class="value">
                适用于个人/组织/企业注册资本≤1000万，若注册资本>1000万/或行政事业单位，请联系
                <a :href="SERVICE_LINK" target="_blank">企业顾问</a>
                定制套餐

                <span class="color-blue"
                      v-if="currentVipInfo.ID == 1001"
                >（张数使用完，不受时间限制随时升级或购买套餐A)</span> </span>
            </div>
          </div>


        </div>
      </div>



      <PayWarmPrompt/>
    </no-ssr>
    <!--  支付成功弹框  -->
    <PaySuccessDialog
      ref="PaySuccessDialog"
      :pay-success-url="paySuccessUrl"
      :btnTxt="btnTxt"
      :vip-full-name="vipFullName"/>
    <!-- 新人注册优惠券   -->
    <!--    <NewUserCoupon
          :new-user-coupon-info="newUserCouponInfo"
          :new-user-coupon-state="newUserCouponState"
          @clickModal="clickModal"
        />-->

  </div>
</template>

<script>
// Components
import HeaderBar from '~/components/pay/header-bar.vue'
import AvatarCombobox from '@/components/common/user/avatar-combobox.vue'
import NewUserCoupon from '@/components/act/new-user-coupon/new-user-coupon'
import CouponPulldown from '@/components/pay/coupon/coupon-pulldown'
import PayWarmPrompt from '@/components/pay/warm-prompt';
import PayTransfer from './transfer'

import {PROTOCOL_PAY_0, USER_CENTER_VIP_COMPANY} from "~/constant/PATH";
import vueQr from 'vue-qr'
import {mapGetters, mapState} from "vuex";
import {fnCoupon, fnGuideDownloadCount, fnLayout, fnRouter} from "@/fn";
import {fnLogin, fnPay} from "@/fn";
import {vipList} from "@/components/pay/module";
import {VIP_LIST, vipType} from "@/constant/VIP";
import {companyStat, tagStat} from "@/api/stat";
import {PaySuccessDialog,} from "@/components/payment/index.js"

import {USER_CENTER} from "@/constant/PATH";
import {getCouponList, getCouponListNew} from "@/api/pay";
import {PAGE_LINK, PAGE_PATH} from "@/constant/PAGE_PATH";
import {VIP_EQUITY_LIST} from "@/components/pay/id/module";
import {
  INTRODUCE_COMPANY_VIP_PLUS,
  SERVICE_LINK,
  INTRODUCE_MULTIPLE,
  PAY_COMPANY_NEW,
  NEW_YEAR_ACT
} from "@/constant/_Public/Path"
import {PAY} from "@/constant/PAY";
import {HOME} from "@/constant/HOME";
import {VIP_MANAGE} from "@/constant/VIP_MANAGE";
import {companyPayByMoreMain} from "@/api/company/pay";
import {COMMON} from "@/constant/COMMON";
import {switchMainAccount} from "@/api/company/home";
import {MANDATE_SCOPE_COMPANY} from "@/constant/_constant/CON_CONFIG";
import {
  checkUserCertification, codeCheckUserCertification, getUserCertificationResult,
  setCertificationModalStatus
} from "@/components/_Privately/User/UserCertificationModal/module";
import {getCookie} from "@/utils/auth";
import {setUserBindIphoneModalStatus} from "@/components/_Privately/User/UserBindIphoneModal/module";

import PicPayQrCode from '@/components/_Privately/Pic/PicPayQrCode'
import {getMainList} from "@/api/company/mandate-record";
import {listObjToArray} from "@/components/tupian/common/list";
import {checkUser} from "@/fn/_Privately/User";
import {disposeVipList} from "@/fn/_Privately/Vip";
import {BLANK_LIST} from "@/constant/_Privately/User";
import mixinCountDown from "@/mixins/mixinCountDown";
import {PAY_WAY} from "@/pages/pay/enterprise-recharge/module";
import _ from 'lodash'
import calendar from "@/utils/Calendar";
import {toolDate} from "@/tools";

export default {
  layout: "LayoutFooter",
  mixins: [mixinCountDown],
  components: {
    vueQr,
    PaySuccessDialog,

    HeaderBar,
    AvatarCombobox,
    NewUserCoupon,
    CouponPulldown,
    PayWarmPrompt,
    PayTransfer,
    PicPayQrCode
  },
  computed: {
    ...mapGetters('user', [
      'phone', 'uniq_id', 'vipIsPerson', 'vipIsPersonData', 'vipIsBusiness', 'vipIsBusinessData', 'avatar', 'iphone', 'isLogin'
    ]),
    ...mapState('user', [
      'phone', 'uniq_id', 'personVipState', 'personVipInfo', 'businessVipState', 'businessVipInfo', 'avatar', 'iphone', 'isLogin'
    ]),
    ...mapState('_Privately/User',
      ['userCertificationModalStatus',
        'userCertificationStatus']),

    vipType() {
      return function (id) {
        let findItem = this.vips.find(vo => vo.ID === id);
        return findItem.CLASS_NAME;
      }
    },

    finalPrice(){
      /* 未登录取 discountPrice 否则 this.currentVipInfo.PRICE
      *  未验证 this.currentVipInfo.PRICE 否则 discountPrice
      *  */
      if (!this.isLogin){
        return this.currentVipInfo.PRICE
      }else{
        if (this.isCertificate){
          return this.discountPrice
        }else{
          return this.currentVipInfo.PRICE
        }
      }
    },
    boxStyle() {
      const leftPosition = this.idIndex * ( 227 + 16) + (227 / 2) - (227 / 2)  + 113;
      return {
        position: 'absolute',
        left: `${leftPosition}px`,
      };
    },
  },
  head() {
    return {
      title: 'VIP会员权限_图片商用授权保障_潮国创意',
      meta: [
        {
          hid: 'keywords',
          name: 'keywords',
          content: '潮国创意提供原创图片素材设计，chaopx.com是一个高品质、高质量正版商用图片素材下载的网站。'
        },
        {
          hid: 'description',
          name: 'description',
          content: '潮国创意提供原创图片素材设计，chaopx.com是一个高品质、高质量正版商用图片素材下载的网站。'
        }
      ]
    }
  },
  data() {
    return {
      PROTOCOL_PAY_0,
      PAY_COMPANY_NEW,
      NEW_YEAR_ACT,
      vipList,
      VIP_LIST,
      isShow: false,
      vipIndex: 0,        /* 会员类型索引 */
      currentVipInfo: {}, /* 当前套餐对象 */
      module: this.$route.params.module || this.$route.query.module | 1,  // 会员支付 1个人/商用 3企业
      vipId: 0,
      paymentShow: false,
      paymentData: {
        isShowWft: false,
        zfbUrl: '',
        wxUrl: '',
        jdUrl: '',
      },
      vipFullName: "",
      paySuccessUrl: '', // 支付成功跳转链接
      timerList: [],
      USER_CENTER,

      couponList: [],  // 红包列表
      newUserCouponInfo: {},
      newUserCouponState: -1,
      discountPrice: 0,
      reducePrice: 0,
      PAGE_LINK,

      VIP_EQUITY_LIST,
      currentEquityInfo: {},
      PAY,

      accountNum: 1,


      /* 新版 */
      id: this.$route.params.id || this.$route.query.id,      // 当前会员套餐( 前端定义唯一id )
      idIndex : 0,
      vipTypeId: 0,    // 会员类型，根据会员信息中的 PARENT_ID
      vips: disposeVipList(PAY.VIPS),
      VIP_MANAGE,
      companyOrder: [], // 企业vip订单
      btnTxt: '进入个人中心',
      memberLeft: 10,
      PAGE_PATH,
      MANDATE_SCOPE_COMPANY,
      isShowScope: false,
      payTimeList: [
        {
          label: '购买1年',
          id: 1,
        },
        {
          label: '购买2年',
          id: 2,
          // tag: '买2年得3年'
        },
        {
          label: '购买4年',
          id: 4,
          // tag: '买4年得6年'
        },
      ],
      payTimeId: 1 ,
      durationActiveIds:[10,300,301,302],
      tempTag: '',
      isCertificate: true,
      selectMainIndex: 0,
      renewMainList: [],
      mainName: '',
      isAdmin: false,
      isCompanyVip: false,
      SERVICE_LINK,
      PAY_WAY,
      payWayIndex:0,
      endVal: 1000,
      showSwiper:false,
      swiperOption3: {
        // autoplay: {
        //   delay: 1000,
        //   speed: 500,
        //   disableOninteraction: true
        // },
        //配置分页
        pagination: {
          el: '.swiper-pagination'//分页的dom节点
        },
        speed: 300,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        direction: "horizontal",
        slidesPerView: 4.15,
        spaceBetween: 24,
        initialSlide: 0, // 默认选中
        loop: false, // 在此无效？？？？？
        // centeredSlides: true, //活动块居中
        // slideToClickedSlide: false, // 点击切换
        lazy: true,
        // slidesPerView:'auto',
        allowTouchMove: false,
        observer: true,//修改swiper自己或子元素时，自动初始化swiper
        observeParents: true,//修改swiper的父元素时，自动初始化swiper
        on: {
          slideChange: () => {
            const c_swiper = document.getElementsByClassName("swiper3");
            // console.log("轮播图滚动事件 --->", c_swiper[0].swiper.activeIndex )
            // this.swiperOption3.initialSlide = c_swiper[0].swiper.activeIndex - 4
          },
        }
      },
      durationIndex: 0,
      ActVipInfo: {
        time:  '',
        timeDesc: '（含购买2年+赠送1年）'
      }

    }
  },
  created() {
    const stat = '充值::图片:onload'
    tagStat({stat})


  },
  async mounted() {
    // this.init();
    fnLayout.setFooterBgColor();
    this.checkWithFindVip();
    this.getMainList();
    // this.checkUserIsCompany();
    this.initTimer()
    // this.getUserCertificationResult();

    await companyStat();
    setTimeout(()=>{
      this.endVal = parseInt(getCookie('MODEL_updateMaterialNum'));
    },100)
    setTimeout(()=>{
      this.showSwiper = true;
    },500)
  },
  watch: {
    userCertificationStatus: {
      handler(n, o) {
        if (n == true) {
          this.checkWithFindVip();
          this.isCertificate = true
        }
      },
    },
    vipTypeId: {
      handler(n, o) {
        if (n) {
          fnPay.payCenterTracking(2)
        }


      },
      immediate: true
    },
    isLogin(n, o) {
      this.clearTimer();
      if (n == true) {

        setTimeout(() => {
          this.checkWithFindVip();
          this.getUserCertificationResult();

        }, 500)
      } else {
        this.couponList = [];
        this.newUserCouponState = -100;
      }
    },
    couponList: {
      handler(n, o) {
        if (this.couponList.length) {
          let findItem = fnPay.findVipByFrontId(this.id)
          let PARENT_ID = this.currentVipInfo.PARENT_ID;

          /*if (PARENT_ID !== VIP_MANAGE.COMPANY.INFO.ID) {
            this.discountPrice = parseFloat(findItem.PRICE) - parseFloat(this.couponList[0].discount_amount);
          }*/

        }
      },
      // immediate: true
    },

    id: {
      handler(n, o) {
        if (n) {
          let findItem = fnPay.findVipByFrontId(n)
          if (findItem) {
            this.currentVipInfo = findItem;   // 当前选中套餐信息
            this.vipTypeId = findItem.PARENT_ID;
            let PARENT_ID = this.currentVipInfo.PARENT_ID;
            /*if (PARENT_ID !== VIP_MANAGE.COMPANY.INFO.ID) {
              this.discountPrice = findItem.PRICE;
            }*/

            this.currentEquityInfo = findItem;
            let findItemVipType = fnPay.getVipTypeByFrontVipId(findItem.PARENT_ID)
            this.currentEquityInfo.title = findItemVipType.title + findItem.mandateNum;
            this.idIndex = this.vips[1].LIST.findIndex(item =>item.ID == n)
          }
        }

        if (n == 38) {
          this.tempTag = '1年限量200张'
        } else if (n == 35) {
          this.tempTag = '限时加赠90天'
        } else if (n == 36) {
          this.tempTag = '限时加赠120天'
        } else if (n == 37) {
          this.tempTag = '限时加赠180天'
        } else {

        }
      },
      immediate: true
    },

    discountPrice: {
      handler(n, o) {

        if (n) {
          let totalPrice = 0;  // 前端计算商品总价
          let PARENT_ID = this.currentVipInfo.PARENT_ID;

          /* 个人和商用VIP 购买 */
          if (PARENT_ID === VIP_MANAGE.PERSON.INFO.ID || PARENT_ID === VIP_MANAGE.BUSINESS.INFO.ID) {

            // this.reducePrice = this.currentVipInfo.PRICE
          }

          /* 企业VIP 购买 */
          if (PARENT_ID === VIP_MANAGE.COMPANY.INFO.ID) {
            if (this.companyOrder.length) {
              let price = 0
              this.companyOrder.forEach(vo => {
                price += vo.accountPrice
              })
              totalPrice = price;
            } else {
              totalPrice = this.currentVipInfo.PRICE * this.accountNum;
            }
          }

        }

      }
    },

    companyOrder: {
      handler(n, o) {
        if (n.length) {
          // this.buyCompanyMain();

          let price = 0
          n.forEach(vo => {
            price += vo.accountPrice
          })
          this.companyOrderPrice = price;

          if (this.couponList && this.couponList.length) {
            // this.checkCheapCoupon();
            this.checkCheapCoupon();
            this.buyCompanyMain(this.couponList[0].id)
          } else {
            this.buyCompanyMain()
          }
        } else {
          this.checkWithFindVip()
        }
      }
    },


    payTimeId:{
      handler(n, o) {
        this.setActVipInfo();
      },
      immediate:true
    },

    currentEquityInfo:{
      handler(n, o) {
        this.setActVipInfo();
      },
      immediate:true

    }
  },

  methods: {

    setActVipInfo(){
      const n = this.currentVipInfo
      if (this.durationActiveIds.indexOf(n.ID)>-1){
          console.log(1111111)


          if (this.payTimeId == 2){

            let days = 365*3;
            if (n.discountMouth2){
              days += n.discountMouth2 * 30
            }
            let nextDay = toolDate.getNextDate(days)
            console.log({nextDay})
            nextDay = nextDay.replace(/-/g, ".");

            this.ActVipInfo.time = nextDay
            // this.ActVipInfo.timeDesc =   (this.payTimeId + 1) +  '年'

            if (n.discountMouthDesc.indexOf('年') > -1){
              this.ActVipInfo.timeDesc = n.discountMouthDesc_all2
            }else{
              this.ActVipInfo.timeDesc =  (this.payTimeId + 1) +  '年'
            }
          }else{
            let nextDay = toolDate.getNextDate(365*1 + n.discountMouth * 30)
            nextDay = nextDay.replace(/-/g, ".");
            this.ActVipInfo.time = nextDay
            if (n.discountMouthDesc.indexOf('年') > -1){
              this.ActVipInfo.timeDesc =n.discountMouthDesc_all
            }else{
              this.ActVipInfo.timeDesc =  (this.payTimeId) +  '年'+  n.discountMouthDesc
            }
          }

        }
    },

    getDateAfterNDays(n){
      const today = new Date();
      return _.add(today, { days: n });
    },

    toggleMemberItem(ID){
      if (this.durationActiveIds.indexOf(ID) > -1){
        // this.payTimeId = 2
      }else{
        this.payTimeId = 1
      }

    },
    toggleDuration(item){
      this.payTimeId = item.id
      this.checkVip(this.currentVipInfo)
    },

    async checkUserIsCompany() {
      this.isCompanyVip = await checkUser("IS_COMPANY_VIP")
      console.log(this.isCompanyVip)
    },
    getMainList() {
      /* {isFull: 1} */
      getMainList().then(res => {
        console.log(res)
        this.renewMainList = listObjToArray(res.data.data);
        /* 设置默认选中 */
        if (this.renewMainList.length) {
          this.mainName = this.renewMainList[0].id;
          this.isAdmin = this.renewMainList.some(item => item.is_admin == 1)
        }
      })
    },

    toggleByMainType(index) {
      this.selectMainIndex = index;
      this.checkVip(this.currentVipInfo)
    },

    changeMain() {
      this.checkVip(this.currentVipInfo)
    },

    async getUserCertificationResult() {
      this.isCertificate = await getUserCertificationResult();
    },

    /* 检查并查找 套餐ID */
    async checkWithFindVip() {
      let findVip = fnPay.findVipByFrontId(this.id)
      if (!findVip) {
        fnRouter.routerTo(PAY_COMPANY_NEW);
        return
      }
      await this.checkVip(findVip)
      // await this.addCart();
    },

    checkVip:_.throttle(async function (findVip, index = 0) {


      try {
        if (process.client) {
          this.mySwiper3.slideTo(index, 1000);
        }
      } catch (e) {
        console.log({e})
      }
      console.log(findVip)
      this.id = findVip.ID;


      console.log()
      this.vipIndex = findVip.PARENT_ID - 1;
      let couponList = await getCouponListNew();
      this.getNewUserCoupon(couponList.data);
      this.couponList = this.filterCouponList(couponList.data.data);
      // this.checkCheapCoupon()

      /* if (findVip.ID >= 36) {
         this.rightMore();
       }
       if (findVip.ID < 36) {
         this.leftMore();
       }*/


      let PARENT_ID = this.currentVipInfo.PARENT_ID;

      console.log({
        PARENT_ID
      })
      /* 个人和商用VIP 购买 */
      if (PARENT_ID === VIP_MANAGE.PERSON.INFO.ID || PARENT_ID === VIP_MANAGE.BUSINESS.INFO.ID) {
        if (this.couponList && this.couponList.length) {
          this.checkCheapCoupon();
          await this.buy(findVip, this.couponList[0].id)
        } else {
          await this.buy(findVip)
        }
      }

      /* 企业VIP 购买 */
      if (PARENT_ID === VIP_MANAGE.COMPANY.INFO.ID) {

        /* 赋值最小accountNum */
        this.accountNum = findVip.ACCOUNT_NUMBER || 1;

        if (this.couponList && this.couponList.length) {
          this.checkCheapCoupon();
          await this.buyCompanyMain(this.couponList[0].id)
        } else {
          await this.buyCompanyMain()
        }

      }
    },1000),


    /* 切换vip */
    async checkVip1(findVip,index = 0) {



      try {

        if (process.client) {
          this.mySwiper3.slideTo(index , 1000);
        }
      }catch (e) {
        console.log({e})
      }
      console.log(findVip)
      this.id = findVip.ID;

      console.log()
      this.vipIndex = findVip.PARENT_ID - 1;
      let couponList = await getCouponListNew();
      this.getNewUserCoupon(couponList.data);
      this.couponList = this.filterCouponList(couponList.data.data);
      // this.checkCheapCoupon()

      /* if (findVip.ID >= 36) {
         this.rightMore();
       }
       if (findVip.ID < 36) {
         this.leftMore();
       }*/


      let PARENT_ID = this.currentVipInfo.PARENT_ID;
      /* 个人和商用VIP 购买 */
      if (PARENT_ID === VIP_MANAGE.PERSON.INFO.ID || PARENT_ID === VIP_MANAGE.BUSINESS.INFO.ID) {
        if (this.couponList && this.couponList.length) {
          this.checkCheapCoupon();
          await this.buy(findVip, this.couponList[0].id)
        } else {
          await this.buy(findVip)
        }
      }

      /* 企业VIP 购买 */
      if (PARENT_ID === VIP_MANAGE.COMPANY.INFO.ID) {

        /* 赋值最小accountNum */
        this.accountNum = findVip.ACCOUNT_NUMBER || 1;

        if (this.couponList && this.couponList.length) {
          this.checkCheapCoupon();
          await this.buyCompanyMain(this.couponList[0].id)
        } else {
          await this.buyCompanyMain()
        }

      }

    },

    /* 切换套餐类型 */
    checkVipType(vo, idx) {
      this.vipTypeId = vo.ID;
      this.vipIndex = idx;
      let tempList = vo.LIST.slice();
      let filterList
      if (vo.ID == 3) {
        filterList = tempList.filter(item => item.isShow)
      } else {
        filterList = tempList;
      }
      this.id = filterList[0].ID;

      this.checkVip(filterList[0])
      // this.checkVip(vo.LIST[0])

    },

    addCart() {
      let {versionName, time, PRICE, ID, ACCOUNT_NUMBER} = this.currentVipInfo
      let unitPrice = parseFloat(PRICE / ACCOUNT_NUMBER).toFixed(2)
      let price = unitPrice * this.accountNum


      /* 升级版/高级版/转售版 */

      let params = {
        txtVip: `${versionName}—¥${PRICE}/1年`,
        txtAccount: `主体子帐号—${this.accountNum}个`,
        txtPrice: `￥${price}`,
        txtPriceNum: ` (￥${unitPrice} x ${this.accountNum})`,
        accountNum: this.accountNum,
        accountPrice: price,
        vip: fnPay.frontVipIdConvertBackend(this.currentVipInfo),
      }

      this.companyOrder.push(params)
      this.accountNum = this.currentVipInfo.ACCOUNT_NUMBER || 1;

    },

    buyCompanyMain(coupon_id) {
      this.getUserCertificationResult();
      /* 判断是否多主体购买 */
      // this.discountPrice = '计算中'

      console.log('coupon_id----')
      console.log(coupon_id)


      if (fnLogin.checkLogin()) {

        this.clearTimer();

        let params = {
          module: 3,
          mainBody: []
        }

        if (this.companyOrder.length) {
          params.mainBody = this.companyOrder.map(vo => {
            return {
              accountNum: vo.accountNum,
              vip: vo.vip,
              duration: this.payTimeId,
              main_id: this.selectMainIndex == 1 ? this.mainName : 0
            }
          })
        } else {
          let p = {
            accountNum: this.accountNum,
            vip: fnPay.frontVipIdConvertBackend(this.currentVipInfo),
            duration: this.payTimeId,
            main_id: this.selectMainIndex == 1 ? this.mainName : 0

          }
          params.mainBody.push(p)
        }


        if (coupon_id) {
          params.coupon_id = coupon_id
        }


        companyPayByMoreMain(params).then(res => {

          /* 灰产账号封禁 */
          if (BLANK_LIST.indexOf(this.uniq_id) > -1) {
            console.log("灰产账号")
            this.$store.commit('Modal/SET_BLANK_MODAL', true)
            return false;
          }


          let payment = {};

          let {ali_pay, wechat_pay,jd_pay, status, amount, discount} = res.data;
          if (status === 1) {
            (wechat_pay.pay_name === 'wft') && (payment.isShowWft = true);
            payment.zfbUrl = ali_pay.code_url;
            payment.wxUrl = wechat_pay.code_img_url;
            payment.jdUrl = jd_pay.code_img_url;
            this.paymentData = payment;
            this.discountPrice = amount
            this.reducePrice = discount

            /* 计算差价 */
            /*if (coupon_id) {
              let findCoupon = this.couponList.find(vo => vo.id == coupon_id)
              console.log(findCoupon)
              if (findCoupon != undefined) {
                let totalPrice = 0
                /!* 折扣券 *!/
                if (this.companyOrder.length) {
                  let price = 0
                  this.companyOrder.forEach(vo => {
                    price += vo.accountPrice
                  })
                  totalPrice = price;
                } else {
                  totalPrice = this.currentVipInfo.PRICE / this.currentVipInfo.ACCOUNT_NUMBER * this.accountNum *  this.payTimeId;
                }

                this.reducePrice = totalPrice - amount

              }
            } else {
              this.reducePrice = 0;
            }
*/

            this.countdown();
            this.getPayResult(ali_pay.order_no)
            this.getPayResult(wechat_pay.order_no)
            this.getPayResult(jd_pay.order_no)
          }

        })
      } else {
        this.$store.commit("user/SET_IS_SHOW_LOGIN", true);
      }

    },

    login() {
      if (!fnLogin.checkLogin()) {
        fnLogin.loginIntercept(false)
      }
    },

    removeCompanyOrderItem(vo, idx) {
      this.companyOrder.splice(idx, 1);
    },

    /* 检查优惠券是否有选中 */
    checkCoupon() {
      let selectCoupon;
      if (this.couponList.length) {
        let tempObj = {}
        this.couponList.map(vo => {
          if (vo.isSelect === true) {
            tempObj = Object.assign({}, vo);
          }
        })
        selectCoupon = tempObj
      }
      return selectCoupon
    },

    /* 查找最优优惠券 */
    checkCheapCoupon(findVip) {

      /* 判断当前VIP类型，普通和个人直接获取价格，企业 1 账号x套餐 2是看购物车列表 */
      let totalPrice = 0;  // 前端计算商品总价
      let PARENT_ID = this.currentVipInfo.PARENT_ID;

      /* 个人和商用VIP 购买 */
      if (PARENT_ID === VIP_MANAGE.PERSON.INFO.ID || PARENT_ID === VIP_MANAGE.BUSINESS.INFO.ID) {
        totalPrice = this.currentVipInfo.PRICE
      }

      /* 企业VIP 购买 */
      if (PARENT_ID === VIP_MANAGE.COMPANY.INFO.ID) {
        if (this.companyOrder.length) {
          let price = 0
          this.companyOrder.forEach(vo => {
            price += vo.accountPrice
          })
          totalPrice = price;
        } else {
          totalPrice = this.currentVipInfo.PRICE * this.accountNum;
        }
      }


      this.couponList.forEach(vo => {
        if (vo.type == 1) {
          vo.FINAL_PRICE = totalPrice - vo.discount_amount
        } else if (vo.type == 2) {
          vo.FINAL_PRICE = (totalPrice * (vo.discount_amount / 10)).toFixed(2);
        }
      })
      this.couponList = this.couponList.sort(_compare('FINAL_PRICE'))

      function _compare(p) {
        return function (m, n) {
          var a = m[p];
          var b = n[p];
          return a - b;
        }
      }

    },


    init() {
      this.checkoutVipId();
      fnLayout.setFooterBgColor();
    },

    togglePayTime(item) {
      this.payTimeId = item.id;
      this.checkVip(this.currentVipInfo)
    },


    getNewUserCoupon(result) {
      let {get_new_user_coupon, status, data} = result;

      let couponList = [];
      for (const key in data) {
        couponList = couponList.concat(data[key])
      }

      if (couponList.length > 0) {
        let currentCoupon;
        for (let i = 0; i < couponList.length; i++) {
          let item = couponList[i]
          if (item.coupon_id == 4 || item.coupon_id == 5) {
            currentCoupon = item;
            break;
          }
        }
        let currentTime = new Date().getTime();
        if (currentCoupon !== undefined) {
          currentCoupon.CountDownTime = (currentCoupon.end_time * 1000) - currentTime;
        }
        this.newUserCouponInfo = currentCoupon
      }

    },

    getCouponList() {
      getCouponListNew().then(res => {
        let {get_new_user_coupon, status, data} = res.data;

        if (status == 1) {
          this.couponList = this.filterCouponList(data);
          // this.checkCheapCoupon()
          // 新用户
          this.newUserCouponState = -100;
          if (get_new_user_coupon == 1) {
            fnGuideDownloadCount.trackNewUser(HOME.NEW_USER_COUPON_TYPE.RED_PACKET, HOME.NEW_USER_COUPON_TYPE.POSITION.CURRENT_PAGE)
            this.newUserCouponState = 1;
            this.$localStorage.setItem('isNewUserCoupon', 1);
            // 查找新人优惠券
            for (const key in data) {
              this.newUserCouponInfo = data[key].find(vo => vo.coupon_id == 4 || vo.coupon_id == 5);
            }
          } else {
            let isNewUserCoupon = this.$localStorage.getItem('isNewUserCoupon')
            if (!!isNewUserCoupon) {
              this.newUserCouponState = isNewUserCoupon;
              for (const key in data) {
                this.newUserCouponInfo = data[key].find(vo => vo.coupon_id == 4 || vo.coupon_id == 5);
              }
            } else {
              this.newUserCouponState = -100;
            }
          }
        }
      })

    },

    toggleCoupon(selectCouponInfo) {
      let {selectCoupon, isSelect} = selectCouponInfo

      clearInterval(this.timer);// 满足条件时 停止计时
      this.clearTimer();

      let PARENT_ID = this.currentVipInfo.PARENT_ID;

      /* 个人和商用VIP 购买 */
      if (PARENT_ID === VIP_MANAGE.PERSON.INFO.ID || PARENT_ID === VIP_MANAGE.BUSINESS.INFO.ID) {
        this.discountPrice = isSelect === true ? (this.currentVipInfo.PRICE - selectCoupon.discount_amount) : this.currentVipInfo.PRICE
        if (isSelect) {
          this.buy(this.currentVipInfo, selectCoupon.id)
        } else {
          this.buy(this.currentVipInfo)
        }
      }

      /* 企业VIP 购买 */
      if (PARENT_ID === VIP_MANAGE.COMPANY.INFO.ID) {
        if (isSelect) {
          this.buyCompanyMain(selectCoupon.id)
        } else {
          this.buyCompanyMain()
        }
      }
    },


    /* 过滤红包列表 */
    filterCouponList(couponList) {
      let _tempCouponList = [];
      // _tempCouponList = couponList[this.currentVipInfo.PARENT_ID] || []
      let findItem = fnPay.findVipByFrontId(this.id)

      for (const key in couponList) {
        if (key == 0 || key == findItem.PARENT_ID) {
          _tempCouponList = _tempCouponList.concat(couponList[key])
        }
      }

      if (_tempCouponList && _tempCouponList.length) {
        _tempCouponList = _tempCouponList.filter(vo => {

          if (vo.vip_type != 0) {
            return vo.vip_type == findItem.REAL_ID && vo.require_amount <= findItem.PRICE
          } else {
            return vo.require_amount <= findItem.PRICE
          }

        })
        _tempCouponList = _tempCouponList.sort(_compare('discount_amount'))
      }


      return _tempCouponList


      function _compare(p) {
        return function (m, n) {
          var a = m[p];
          var b = n[p];
          return a - b;
        }
      }
    },

    async buy(vo, coupon_id) {
      console.log(coupon_id)
      console.log(this.couponList)

      /* 计算差价 */
      /*if (coupon_id) {
        let findCoupon = this.couponList.find(vo => vo.id == coupon_id)
        console.log('findCoupon')
        console.log(findCoupon)

        if (findCoupon != undefined) {
          this.reducePrice = findCoupon.discount_amount
        }
      } else {
        this.reducePrice = 0;
      }*/

      if (fnLogin.checkLogin()) {
        this.timerList.forEach((item, index) => {
          clearInterval(item);
        })

        let tempId, module;
        if (vo.PARENT_ID === 3) {
          // tempId = vo.ID === 9 ? 1 : 2;

          if (vo.ID === 9) {
            tempId = 1
          } else if (vo.ID === 10) {
            tempId = 2
          } else if (vo.ID === 33) {
            tempId = 3
          } else if (vo.ID === 34) {
            tempId = 4
          } else if (vo.ID === 35) {
            tempId = 5
          } else if (vo.ID === 36) {
            tempId = 6
          } else if (vo.ID === 37) {
            tempId = 7
          }

        } else if (vo.PARENT_ID === 1) {
          if (vo.ID === 19) {
            tempId = 9
          } else {
            tempId = vo.ID
          }
        } else {
          tempId = vo.ID
        }

        module = (vo.PARENT_ID === 2 || vo.PARENT_ID === 1) ? 1 : 3

        /* 灰产账号封禁 */
        if (BLANK_LIST.indexOf(this.uniq_id) > -1) {
          console.log("灰产账号")
          this.$store.commit('Modal/SET_BLANK_MODAL', true)
          return false;
        }

        await fnPay.getPayCode(tempId, module, coupon_id).then(res => {
          let {payment, ali_pay, wechat_pay, amount, discount} = res;
          this.paymentData = payment;
          this.discountPrice = amount;
          /*if (coupon_id) {
            this.reducePrice = this.currentVipInfo.PRICE - amount
          } else {
            this.reducePrice = 0
          }*/
          this.reducePrice = discount
          this.countdown();
          this.getPayResult(ali_pay.order_no)
          this.getPayResult(wechat_pay.order_no)


        })
      } else {
        this.$store.commit("user/SET_IS_SHOW_LOGIN", true);
      }
    },
    countdown() {
      let second = 5 * 60;
      let vm = setInterval(() => {
        second--;
        if (second < 1) {
          clearInterval(vm);
          clearInterval(this.timer);// 满足条件时 停止计时
          this.clearTimer();
        }
      }, 1000)
    },

    getPayResult(order_no) {

      // this.$store.dispatch('user/getUserInfo')
      this.timer = setInterval(() => {
        fnPay.getPayResult(order_no).then(res => {
          if (res.status == 1) {


            this.checkVip(this.currentVipInfo)

            this.vipFullName = this.currentVipInfo.LABEL;
            this.$refs.PaySuccessDialog.isShow = true;

            let PARENT_ID = this.currentVipInfo.PARENT_ID;
            if (PARENT_ID === VIP_MANAGE.COMPANY.INFO.ID) {
              this.vipFullName = '全站通VIP';
              this.toggleCompany();
              this.btnTxt = '进入全站通VIP后台';
              this.paySuccessUrl = 'https://chaopx.com/company'
            } else {
              this.btnTxt = '进入个人中心';

            }
            this.$store.dispatch('user/getUserInfo')
            this.$store.dispatch('user/GetUserVipInfo')
            fnLogin.updateUserVipAll();

            clearInterval(this.timer);// 满足条件时 停止计时
            this.timerList.forEach((item, index) => {
              clearInterval(item);
            })
            this.timerList = [];
            this.timer = 0;
          }
        })
      }, 2000)
      this.timerList.push(this.timer)
    },


    toggleCompany() {
      switchMainAccount({
        'type': 1,
        'mainid': 0
      }).then(res => {
        console.log(res)
        if (res.data.status === 200) {
          this.$store.dispatch('user/getCompanyInfoByPerson')
          this.$store.dispatch('user/getUserInfo');
        }
      })
    },

    closeDialog() {
      this.isShow = false;
      this.$emit('closePayDialog');
    },

    clearTimer() {
      clearInterval(this.timer);// 满足条件时 停止计时
      if (this.timer) {
        this.timerList.forEach((item, index) => {
          clearInterval(item);
        })
        this.timerList = [];
        this.timer = 0;
      }
    },

    clickModal() {
      let findVip = fnPay.getCurrentVipInfo((2))
      this.toggleMeal(findVip);
    },

    inputByAccount() {
      this.accountNum = this.accountNum.replace(/[^\d]/g, '');
      this.accountNum = this.accountNumLimit(this.accountNum)

      if (this.currentEquityInfo && this.accountNum <= this.currentEquityInfo.ACCOUNT_NUMBER) {
        this.accountNum = this.currentEquityInfo.ACCOUNT_NUMBER
      }

      if (this.companyOrder.length == 0) {
        if (this.couponList && this.couponList.length) {
          this.checkCheapCoupon();
          this.buyCompanyMain(this.couponList[0].id)
        } else {
          this.buyCompanyMain()
        }
      }
    },
    updateAccountNum(type) {
      if (type === PAY.ACCOUNT_CART_HANDLE.ADD) {
        this.accountNum += 1;
      } else {
        this.accountNum -= 1
      }
      this.accountNum = this.accountNumLimit(this.accountNum)

      /* 判断具体套餐最小账户值 */

      if (this.currentEquityInfo && this.accountNum <= this.currentEquityInfo.ACCOUNT_NUMBER) {
        this.accountNum = this.currentEquityInfo.ACCOUNT_NUMBER
      }

      if (this.companyOrder.length == 0) {
        if (this.couponList && this.couponList.length) {
          this.checkCheapCoupon();
          this.buyCompanyMain(this.couponList[0].id)
        } else {
          this.buyCompanyMain()
        }
      }
    },

    accountNumLimit(num) {
      if (num <= 0) {
        num = 1
      }
      if (num > 999) {
        num = 999
      }
      return num;
    },

    rightMore() {
      this.memberLeft = -214;
    },
    leftMore() {
      this.memberLeft = 10;
    },

    codeCheckUserCertification() {
      codeCheckUserCertification();
    },
    showLogin(){
      if (!fnLogin.checkLogin()) {
        this.$store.commit('user/SET_IS_SHOW_LOGIN', true);
      }
    }
  },
  filters: {
    filterTime(val) {
      return val.slice(0, 10)
    },
    disposeReducePrice(val) {
      return parseFloat(val).toFixed(1);
    },
    mealDuration(val) {
      let vNum = parseInt(val)
      if (vNum === 1 || vNum === 2) {
        return '1年'
      } else if (vNum === 6 || vNum === 5) {
        return '90天'
      } else if (vNum === 4 || vNum === 7) {
        return '30天'
      } else if (vNum === 19) {
        return '终身'
      }
    },

  }
}
</script>


<style lang="scss" scoped>
@import "id.scss";
@import "components/pay/id/qr.scss";
@import "index";

.real-coupon{
  @include BgImage2(174px,28px,"pay/real-coupon.png")
  display: flex;
  align-items: center;
  position: absolute;
  left: -70px;
  top: 68%;
  transform: translateY(-50%);

  &:after{
    content: "";
    display: inline-block;
    width: 1px;
    height: 16px;
    background: rgba(0,0,0,0.2);
    position: absolute;
    left: 45px;
    top: 50%;
    transform: translateY(-50%);
  }

  .txt-price{
    width: 45px;
    font-weight: bold;
    font-size: 13px;
    color: #FF4216;
    text-align: center;
  }

  .txt-coupon{
    font-size: 12px;
    color: rgba(0,0,26,0.85);
    padding-left: 6px;
  }
  .txt-time{
    margin-left: 4px;
    font-size: 12px;
    color: #FF4216;
  }

}
.text-sq{
  margin: 16px 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 1200px;
  height: 40px;
  background: rgba(105,105,255,0.09);
  border-radius: 8px;
  margin: 0 auto;

  .label{
    font-size: 14px;
    color: rgba(0,0,26,0.5);
    line-height: 19px;
    margin-right: 24px;
  }
  .value{
    font-size: 14px;
    color: rgba(0,0,26,0.75);
    line-height: 19px;
    .color-blue{
      color: rgba(133, 34, 251, 1);
    }
  }
  a{
    font-weight: bold;
    color: rgba(0,0,26,0.75);
    text-decoration: underline;
  }

}

.swiper-box{
  width: 1200px;
  margin: 0 auto;
}
//
//.swiper-box{
//  width: 1132px;
//  position: relative;
//  margin-left: 40px;
//  .swiper3{
//    width: 100%;
//  }
//}
//
//.swiper-button-next{
//  @include BgImage2(50px,50px,'pay/arrow.png');
//  transform: rotate(180deg);
//  right: -30px;
//  &:hover{
//    @include BgImage2(50px,50px,'pay/arrow@hover.png');
//    transform: rotate(180deg);
//  }
//  &.swiper-button-disabled{
//    @include BgImage2(50px,50px,'pay/arrow.png');
//    display: none;
//  }
//}
//.swiper-button-prev{
//  @include BgImage2(50px,50px,'pay/arrow.png');
//  left: -30px;
//  &:hover{
//    @include BgImage2(50px,50px,'pay/arrow@hover.png');
//  }
//  &.swiper-button-disabled{
//    @include BgImage2(50px,50px,'pay/arrow.png');
//    display: none;
//  }
//}
//
//.pay-item-meal{
//  margin-bottom: 0 !important;
//}
//.member-list{
//  padding: 30px 0 20px 0;
//}
//.member-item{
//  &:not(:last-child){
//    margin-right: 24px;
//  }
//  &:last-child{
//    margin-right: 0 !important;
//  }
//
//}
</style>
